
import LoginForm from "../components/LoginForm";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const Login = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <div className="flex items-center justify-center h-screen">Loading...</div>;
  }

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="w-full max-w-md flex flex-col items-center">
        <div className="mb-6">
          <div className="flex gap-2 items-center">
            <div className="bg-primary w-10 h-10 rounded-xl flex items-center justify-center">
              <span className="text-primary-foreground font-bold text-xl">CP</span>
            </div>
            <h1 className="text-2xl font-bold">CoopPreschool</h1>
          </div>
          <p className="text-center text-muted-foreground mt-2">
            Parent-run preschool management system
          </p>
        </div>
        <LoginForm />
      </div>
    </div>
  );
};

export default Login;
